import React from 'react';
import AryPinnedTable from './AryPinnedTable';

const AryNotSelectablePinnedTable = ({
  data,
  columns,
  pinnedColumnsList,
  noContentBox,
  customNoContent,
  tableSx,
  stickyHeadSx,
  onHover,
  isFlat,
  page,
  pageCount,
  clickedRowIndex,
  setClickedRowIndex,
  tableRef
}) => (
  <AryPinnedTable
    data={data}
    columns={columns}
    pinnedColumnsList={pinnedColumnsList}
    noContentBox={noContentBox}
    customNoContent={customNoContent}
    tableSx={tableSx}
    stickyHeadSx={stickyHeadSx}
    onHover={onHover}
    isFlat={isFlat}
    page={page}
    pageCount={pageCount}
    clickedRowIndex={clickedRowIndex}
    setClickedRowIndex={setClickedRowIndex}
    tableRef={tableRef}
    defaultTableSelection="true"
  />
);

export default AryNotSelectablePinnedTable;
